import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

import { useAPIAuthenticatedService } from '../../helpers/APICallsAuthenticated';
import { CacheKeys } from '../../helpers/DataStructures';
import Busy from '../../components/Busy';
import ReferralOutDetailContent from './ReferralOutDetailContent';
import ReferralConversationCounterpartyHeader from './ReferralConversationCounterpartyHeader';
import ReferralRouteShell from './ReferralRouteShell';

const ReferralSentDetailPage: React.FC = () => {
  const apiServiceInstance = useAPIAuthenticatedService();
  const { referralId } = useParams();
  const parsedReferralId = referralId ? Number(referralId) : NaN;
  const isValidReferralId = Number.isInteger(parsedReferralId) && parsedReferralId > 0;

  const { isLoading, isError, data } = useQuery(
    [CacheKeys.REFERRAL_BY_ID, parsedReferralId],
    () => apiServiceInstance.getReferralById(parsedReferralId),
    // REQ-001: do not keep the previous referral visible while a new detail route loads.
    { enabled: isValidReferralId }
  );

  const isUnavailable =
    !isValidReferralId ||
    data === null ||
    (data !== undefined && data !== null && data.user.isMe !== true);

  return (
    <ReferralRouteShell
      backTo="/dashboard/referrals/out"
      headerLeft={
        !isValidReferralId || isLoading || isError || isUnavailable || !data ? null : (
          <ReferralConversationCounterpartyHeader referral={data} isOfferOwner={false} />
        )
      }
    >
      {!isValidReferralId ? (
        <Typography>Referral unavailable.</Typography>
      ) : isLoading ? (
        <Busy message="Loading referral..." />
      ) : isError ? (
        <Typography>Unable to load this referral.</Typography>
      ) : isUnavailable ? (
        <Typography>Referral unavailable.</Typography>
      ) : (
        <ReferralOutDetailContent referral={data} showCounterpartyHeader={false} />
      )}
    </ReferralRouteShell>
  );
};

export default ReferralSentDetailPage;
